import React, { useState } from "react";
import { Modal, Button, Row, Col, Image } from "react-bootstrap";
import { IonIcon } from "@ionic/react";
import { homeOutline, resizeOutline, pricetagOutline } from "ionicons/icons";
import ImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";

export const housesGraus = [
  {
    images: [
      { url: "https://aldealista.com/news/fabero/houses/01/01.jpg" },
      { url: "https://aldealista.com/news/fabero/houses/01/02.jpg" },
      { url: "https://aldealista.com/news/fabero/houses/01/03.jpg" },
      { url: "https://aldealista.com/news/fabero/houses/01/04.jpg" },
      { url: "https://aldealista.com/news/fabero/houses/01/05.jpg" },
      { url: "https://aldealista.com/news/fabero/houses/01/06.jpg" },
      { url: "https://aldealista.com/news/fabero/houses/01/07.jpg" },
      { url: "https://aldealista.com/news/fabero/houses/01/08.jpg" },
      { url: "https://aldealista.com/news/fabero/houses/01/09.jpg" },
    ],
    url: "https://www.idealista.com/inmueble/105401764/",
    address: "Jesús y María, 1",
    contact: "",
    title: "Alquiler de Piso, Fabero",
    description:
      "A un minuto a pié de la plaza del Ayuntamiento, cuenta con tres habitaciones, un baño, cocina amplia con vitrocerámica, frigorífico combi, microondas y horno, salón comedor y terraza cubierta. Está bien aislado, prácticamente no necesita usar calefacción. Calefacción central de aerotermia, el uso de la calefacción y agua caliente se regula mediante termostato y se paga por energía usada.\n\nAgua e Internet incluido en el precio.\n\nAbastecimiento de luz mediante prepago, sin necesidad de darse de alta en ninguna compañía.\n\nTambién hay posibilidad de alquilar por días o semanas.\n\n",
    size: "154",
    price: "490",
  },
  {
    images: [
      { url: "https://aldealista.com/news/fabero/houses/02/01.jpg" },
      { url: "https://aldealista.com/news/fabero/houses/02/02.jpg" },
      { url: "https://aldealista.com/news/fabero/houses/02/03.jpg" },
      { url: "https://aldealista.com/news/fabero/houses/02/04.jpg" },
      { url: "https://aldealista.com/news/fabero/houses/02/05.jpg" },
      { url: "https://aldealista.com/news/fabero/houses/02/06.jpg" },
      { url: "https://aldealista.com/news/fabero/houses/02/07.jpg" },
      { url: "https://aldealista.com/news/fabero/houses/02/08.jpg" },
      { url: "https://aldealista.com/news/fabero/houses/02/09.jpg" },
      { url: "https://aldealista.com/news/fabero/houses/02/10.jpg" },
      { url: "https://aldealista.com/news/fabero/houses/02/11.jpg" },
      { url: "https://aldealista.com/news/fabero/houses/02/12.jpg" },
      { url: "https://aldealista.com/news/fabero/houses/02/13.jpg" },
      { url: "https://aldealista.com/news/fabero/houses/02/14.jpg" },
      { url: "https://aldealista.com/news/fabero/houses/02/15.jpg" },
      { url: "https://aldealista.com/news/fabero/houses/02/16.jpg" },
    ],
    url: "https://www.fincasgraus.com/inmueble/chalet-adosado-en-venta-en-graus/21461877",
    address: "Real, 36",

    contact: "974 546 536",
    title: "Alquiler de piso, Fabero",
    description:
      "Calefacción-agua caliente con Gasoil. Faltaría ropa de cama para dos de las habitaciones que están amuebladas y utensilios (platos, cubiertos, etc... )para la cocina. Después hay dos huecos que se pueden habilitar de oficina, zona de plancha o habitaciones. Estos dos huecos están sin amueblar.",
    size: "160",
    price: "485",
  },
];

const HouseList = () => {
  return (
    <div
      className="horizontal-slider-container"
      style={{
        margin: 0,
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        padding: "10px",
        maxWidth: "650px",
        width: "100vw",
      }}
    >
      {housesGraus.map((house, index) => (
        <HouseItem key={index} house={house} />
      ))}
    </div>
  );
};

const HouseItem = ({ house }) => {
  const [showModal, setShowModal] = useState(false);

  const handleShow = () => setShowModal(true);
  const handleClose = () => setShowModal(false);

  // Prepare images for react-image-gallery
  const galleryImages = house.images.map((img) => ({
    original: img.url,
    thumbnail: img.url,
  }));

  return (
    <>
      {/* Summary Card */}
      <div
        onClick={handleShow}
        style={{
          backgroundColor: "white",
          color: "black",
          padding: "10px",
          cursor: "pointer",
          borderBottom: "1px solid #a6c693",
        }}
      >
        <Row>
          <Col
            xs={4}
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Image
              src={house.images[0].url} // Display the first image
              fluid
              style={{ width: "150px", height: "auto", objectFit: "cover" }}
            />
          </Col>
          <Col xs={8}>
            <h5>{house.title}</h5>
            <p>
              <IonIcon icon={resizeOutline} style={{ marginRight: 8 }} />
              {house.size} m²
            </p>
            <p>
              <IonIcon icon={pricetagOutline} style={{ marginRight: 8 }} />€
              {house.price}
            </p>
            <p
              style={{
                display: "-webkit-box",
                WebkitBoxOrient: "vertical",
                WebkitLineClamp: 4, // Limit description to 4 lines
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
              dangerouslySetInnerHTML={{
                __html: house.description.replace(/\n/g, "<br />"),
              }}
            />
          </Col>
        </Row>
      </div>

      {/* Modal with Full Details */}
      <Modal show={showModal} onHide={handleClose} centered size="lg">
        <Modal.Header closeButton>
          <Modal.Title>{house.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* Image Slider */}
          <ImageGallery
            items={galleryImages}
            showThumbnails={true}
            showPlayButton={false}
          />

          {/* Full Details */}
          <div style={{ marginTop: "20px" }}>
            <p>
              <IonIcon icon={homeOutline} style={{ marginRight: 8 }} />
              {house.address || "Address not provided"}
            </p>
            <p>
              <IonIcon icon={resizeOutline} style={{ marginRight: 8 }} />
              {house.size} m²
            </p>
            <p>
              <IonIcon icon={pricetagOutline} style={{ marginRight: 8 }} />€
              {house.price}
            </p>
            <p
              dangerouslySetInnerHTML={{
                __html: house.description.replace(/\n/g, "<br />"),
              }}
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" href={house.url} target="_blank">
            Saber más
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default HouseList;
